import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePreference } from '../../modules/preferences/actions.js';
import { getPreferenceValue } from '../../modules/preferences/selectors.js';

/**
 * A hook to retrieve or update a single preference value
 * @param {string} key Preference key to find
 * @returns {[]} An array in the format: [value, setValue]
 * @returns {*} `value` The current preference value, or undefined if the key does not exist
 * @returns {function} `setValue` A function to update the preference value, takes a single argument for the new value to set
 */

var usePreferenceValue = function usePreferenceValue(key) {
  var dispatch = useDispatch();
  var value = useSelector(function (state) {
    return getPreferenceValue(state, key);
  });
  var setValue = useCallback(function (newValue) {
    dispatch(updatePreference(key, newValue));
  }, [dispatch, updatePreference, key]);
  return [value, setValue];
};

var usePreferenceValue$1 = usePreferenceValue;

export { usePreferenceValue$1 as default };
